import { useDynamicViewSchema } from "src/dynamic-view-renderer/DynamicViewSchemaProvider/DynamicViewSchemaProvider";
import { PrintableProperties } from "src/dynamic-view-renderer/PrintableWidgets/PrintableWidgetContainer";
import { useT } from "src/internationalization";
import { ClientSchema } from "src/types/clientSchema";

import { BasicWidgetProps } from "../Widgets/BasicWidget/BasicWidget";
import { WidgetDefinition } from "../Widgets/Widget.typings";
import { useGetWidgetProperties } from "../Widgets/WidgetProperties";

export function PrintableBasicWidget({
  definition,
  data,
  caseSchema,
}: {
  definition: WidgetDefinition;
  data: BasicWidgetProps["data"];
  caseSchema: ClientSchema;
}) {
  const { propertyDefinitions } = useDynamicViewSchema();
  const getWidgetProperties = useGetWidgetProperties();
  const t = useT();
  const properties = [
    ...(data?.item.customProperties ?? []),
    ...getWidgetProperties({
      widgetDefinition: definition,
      data,
      itemSchema: caseSchema,
      propertyDefinitions,
    }),
  ];
  return properties.length ? (
    <PrintableProperties properties={properties} keepTogether={properties.length <= 8} />
  ) : (
    <p>{t("general.table.empty")}.</p>
  );
}
